import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './ForgotPasswordConfirmationCardStyles';
import {
    Button,
    Container,
} from '@mui/material';
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    settings: any,
}

const ForgotPasswordConfirmationCard: React.FC<Props> = props => {

    const { classes } = useStyles()
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateForgotPassword = () => {
        let path = '/forgotPassword';
        history.push(path);
    }

    const navigateLogin = () => {
        let path = '/home';
        history.push(path);
    }

    return (
        <AuthPage
            title="Check your email!"
            icon={<MdOutlineMarkEmailRead />}
            actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateLogin}>Go To Log In</button>}>
            <p>If you provided us with the correct email address used to create your account, please check your email and follow the provided link to reset your password.</p>
            <p>If you do not receive an email, please check your <strong>spam folder</strong>.</p>
            <p>Please also make sure you entered the email associated with your account, or try a <a className="pb-auth-link" onClick={navigateForgotPassword}>different email</a>.</p>
        </AuthPage>
    )

}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(ForgotPasswordConfirmationCard);